import { useEffect, useState } from "react";

const useAutoPlay = videoRef => {
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const tryAutoPlay = async () => {
      if (videoRef.current) {
        try {
          videoRef.current.muted = true; // Mute video to auto-play
          await videoRef.current.play();
          setIsPlaying(true);
        } catch (error) {
          console.error("Auto-play failed:", error);
          setIsPlaying(false);
        }
      }
    };

    tryAutoPlay();
  }, [videoRef]);

  return isPlaying;
};

export default useAutoPlay;
